import { ModuleId } from '../types';
import { TIERS, TierConfig } from './tiers';
import { MODULES } from '../data/modules';

// System Groups
export type GroupId = 6 | 7 | 8;
export const GROUPS: GroupId[] = [6, 7, 8];

// Starting Period — when the student stepped into their group
export type StartingPeriod = 'B' | 'M' | 'E';
export const STARTING_PERIODS: {
  id: StartingPeriod;
  label: string;
  description: string;
}[] = [{
  id: 'B',
  label: 'Begin',
  description: 'Start van het schooljaar'
}, {
  id: 'M',
  label: 'Midden',
  description: 'Halverwege het schooljaar'
}, {
  id: 'E',
  label: 'Eind',
  description: 'Einde van het schooljaar'
}];

/**
 * Get the starting tier for a group + period combination.
 * Maps to the first (non-plus) tier of that period.
 * E.g., Group 7 + Period M → M7 (tier 9)
 */
export function getStartingLevelForPeriod(group: GroupId, period: StartingPeriod): number {
  const match = TIERS.find(t => t.group === group && t.period === period && !t.isPlus);
  // Fallback to first tier of group
  return match?.tier ?? TIERS.find(t => t.group === group)?.tier ?? 1;
}

// Configuration Interface
export interface SystemConfig {
  groups: GroupId[];
  modules: typeof MODULES;
  tiers: TierConfig[];
  version: string;
}

// Centralized System Configuration
export const SYSTEM_CONFIG: SystemConfig = {
  groups: GROUPS,
  modules: MODULES,
  tiers: TIERS,
  version: '3.0.0'
};

// Helper to get tiers for a specific group
export const getTiersForGroup = (group: GroupId): TierConfig[] => {
  return TIERS.filter(tier => tier.group === group);
};

// Validation Utilities
export interface ValidationResult {
  valid: boolean;
  issues: ValidationIssue[];
}
export interface ValidationIssue {
  type: 'error' | 'warning' | 'info';
  message: string;
  entityId?: string;
  entityType?: 'question' | 'module' | 'tier';
}